const Loaders = () => {
	return (
		<div className="container-loading">
			<div className="Loading"></div>
		</div>
	);
};

export default Loaders;
